import ContactForm from "./ContactForm"


export default function Contact () {

    return (
        <>
        <section id="contact">
            <div className="container-main">
                <h2>questions? feel free to reach out.</h2>
                <ContactForm />
            </div>
        </section>
        
        </>
    )
}